export default __webpack_public_path__ + "static/media/8.7d645465.png";